import React, { useEffect } from "react";
import "whatwg-fetch";
import StripeButton from "components/Header/StripeButton";
import iconSettings from "images/video_custom.svg";
import { Button } from "aible";
import Logo_Aible_Anywhere from "images/Aible_Logo/Aible_Anywhere.svg";
import Logo_Aible_Advanced from "images/Aible_Logo/Aible_Advanced.svg";
import Logo_Aible_Business from "images/Aible_Logo/Aible_Business.svg";
import Logo_Aible_Collaborate from "images/Aible_Logo/Aible_Collaborate.svg";
import Logo_Aible_Collaborate_New from "images/Aible_Collaborate_reversed.svg";
import Logo_Aible_Data from "images/Aible_Logo/Aible_Data.svg";
// import Logo_Aible_For_One from "images/Aible_Logo/Aible_For_One.svg";
import Logo_Aible_Mobile_Monitor from "images/Aible_Logo/Aible-Overview-Horizontal-Dark-Bg.svg";
import Logo_Aible_For_One from "images/Aible_Logo/AFOLogo.png";
import Logo_Aible_EDG from "images/Aible_Logo/Aible_EDG.svg";
import Logo_Aible_Sense from "images/Aible_Logo/Aible_Sense_logo.svg";
import Logo_Aible_Anywhere_Orange from "images/Aible_Anywhere_reveresed- white_orange.svg";
import Logo_Aible_Sense_Plus from "images/Aible_Logo/aible-sense-plus.svg";
// import Logo_Aible_Optimize from "images/Aible_Logo/Aible_Optimize.svg";
import Logo_Aible_Next from "images/Aible_Logo/AibleNextLogo.svg";
import Logo_Aible_Transparent from "images/Aible_Logo/aible-logo.svg";
import DellPoweredByAibleLogo from "images/Aible_Logo/dell-powered-by-aible.svg";
import Logo_Aible_Marketplace from "images/Aible_Logo/Aible_Marketplace_Product_Logo.svg";
import Logo_ChatAible from "images/Aible_Logo/chataible.svg";
import Logo_ChatAible_Beta from "images/Aible_Logo/chataible-beta.svg";
import Logo_Powered_By_Aible from "images/Aible_Logo/aible-powered-light.svg";
import Logo_Powered_By_Aible_Dark from "images/Aible_Logo/aible-powered-dark.svg";
import styles from "./style.module.css";
import { isEnabled } from "utils/featureFlags";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import folderIcon from "images/folder-migrate-white.svg";
import folderIconDark from "images/folder-migrate-dark.svg";
import tasksIcon from "images/tileIcons/target_white.svg";
import tasksIconDark from "images/tileIcons/target_dark.svg";
import globeIcon from "images/tileIcons/globe-white.svg";
import globeIconDark from "images/tileIcons/globe-dark.svg";
import MarketplaceIcon from "images/marketplaceIcon.svg";
import MarketplaceIconDark from "images/marketplaceIcon-dark.svg";
import marketplaceLogo from "images/tileIcons/shopping-cart-light.svg";
import marketplaceLogoDark from "images/tileIcons/shopping-cart-dark.svg";
import questionCircle from "images/tileIcons/question-circle-light.svg";
import questionCircleDark from "images/tileIcons/question-circle-dark.svg";
import logoutLogoDark from "images/tileIcons/sign-out-dark.svg";
import pathFind from "images/tileIcons/walkthrough.svg";
import pathFindDark from "images/tileIcons/walkthrough-dark-mode.svg";
import CreateConsultantModalContainer from "containers/Market/Consultants/CreateConsultantModal";
import CreateJobModal from "containers/Market/Jobs/CreateJobModal";
import { VIEW_TYPE } from "containers/View/reducer";
import { toast } from "react-toastify";
import CostSavingsIndicator from "components/Header/CostSavingsIndicator";
import { useSelector, useDispatch } from "../../types/store";
import * as loginReducer from "../../containers/Login/reducer";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getInitials } from "../../utils/getInitials";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as globalReducer from "containers/App/reducer";
const Header = (props) => {
    const { isLeftPanelOpen, selectedAccount, handleLogout, uploadContainer, updateIsLeftPanelOpen, history, isMarketplaceDemo, isMarketplace, tableauData, isTableauMode, isConsumerMode, isBusinessMode, isDataMode, isEDGMode, isDellDomain, updateIsConsumerMode, updateIsTableauMode, updateIsBusinessMode, updateIsTourOpen, updateCollaborateIsTourOpen, updateIsTourOpenSense, updateIsTourOpenExplore, updateIsOpenNewChat, updateIsDataMode, updateDatasetId, updateType, location, goToHelpUri, viewingMobile, isNextEnabled, activeTab, viewType, accounts, accountsIsLoading, headerMode, updateHeaderMode, chatApp, headerDarkMode, uiState, agentAutonomyView, updateAgentAutonomyView, aibleViewType, isGoogleMode } = props;
    const dispatch = useDispatch();
    const userName = useSelector((state) => loginReducer.getUserName(state));
    const userEmail = useSelector((state) => loginReducer.getUserEmail(state));
    const getIsNvidiaDeployment = () => {
        let isNvidiaDeployment = false;
        if (window?.location?.hostname?.indexOf("nvidia.iamaible.com") !== -1 ||
            window?.location?.hostname?.indexOf("halloween.d.aiplusi.com") !== -1) {
            isNvidiaDeployment = true;
        }
        return isNvidiaDeployment;
    };
    const getImage = () => {
        let viewMode;
        const useChatAppLogo = ((location && location.pathname && location.pathname.indexOf("next") !== -1) ||
            (viewType === "new chat" &&
                location &&
                location.pathname &&
                location.pathname.indexOf("chatTemplate") === -1)) &&
            chatApp?.wizard?.base64StringLogo !== undefined &&
            chatApp?.wizard?.base64StringLogo !== "";
        if (useChatAppLogo) {
            return chatApp?.wizard?.base64StringLogo;
        }
        if (getIsNvidiaDeployment()) {
            return Logo_Aible_Transparent;
        }
        if (isDellDomain) {
            return DellPoweredByAibleLogo;
        }
        if (isEnabled("chat-aible-beta-warning")) {
            return Logo_ChatAible_Beta;
        }
        if (location && location.pathname) {
            const currPath = location.pathname.split("/");
            viewMode = currPath && String(currPath[1]).toLowerCase();
        }
        const isLookerMode = window?.looker_API !== undefined;
        if (isLookerMode || isEnabled("chat-aible-consumer")) {
            return Logo_ChatAible;
        }
        if (isTableauMode || isGoogleMode || (location?.pathname && location.pathname.indexOf("/project_next/") !== -1)) {
            return Logo_Aible_Anywhere_Orange;
        }
        if (location?.pathname && location.pathname.indexOf("/explore/") !== -1) {
            return Logo_Aible_Anywhere;
        }
        if (isEnabled("aible-consumer")) {
            return Logo_Aible_Collaborate_New;
        }
        if (isEnabled("aible-optimize")) {
            return Logo_Aible_Transparent;
        }
        if (isEnabled("aible-sense")) {
            if (isEnabled("sense-transformations")) {
                return Logo_Aible_Sense_Plus;
            }
            return Logo_Aible_Sense;
        }
        if (isEnabled("aible-explore")) {
            return Logo_Aible_Transparent;
        }
        if (isEnabled("chat-aible")) {
            return Logo_ChatAible;
        }
        const isNext = true;
        if (isNext) {
            return Logo_Aible_Next;
        }
        if (tableauData || isTableauMode) {
            return Logo_Aible_For_One;
        }
        if (isEDGMode) {
            return Logo_Aible_EDG;
        }
        if (isDataMode) {
            return Logo_Aible_Data;
        }
        // Check view mode first, so the banner overrides any flags the user has
        if (viewMode === "business" || isNext) {
            return Logo_Aible_Business;
        }
        else if (viewMode === "project") {
            return Logo_Aible_Advanced;
        }
        else if (viewMode === "collaborate") {
            return Logo_Aible_Collaborate;
        }
        else if (viewMode === "market") {
            return Logo_Aible_Marketplace;
        }
        if (isBusinessMode) {
            return Logo_Aible_Business;
        }
        if (viewingMobile) {
            return Logo_Aible_Mobile_Monitor;
        }
        if (isEnabled("aible-consumer")) {
            return Logo_Aible_Collaborate;
        }
        return Logo_Aible_Advanced;
    };
    let viewMode;
    if (location && location.pathname) {
        let currPath = location.pathname.split("/");
        viewMode = currPath && String(currPath[1]).toLowerCase();
    }
    const hideHeader = location &&
        (location.pathname.includes("/login") ||
            location.pathname.includes("/upload") ||
            location.pathname.indexOf("/registration") !== -1 ||
            location.pathname === "/reset");
    const isViewingExplore = location.pathname.includes("/next/") && activeTab === "EXPLORE";
    const isViewingDataTab = location.pathname === "/" && viewType === VIEW_TYPE.DATASETS;
    const isNewChat = location.pathname === "/" && viewType === VIEW_TYPE.NEW_CHAT;
    const isLinkShare = uiState?.type === "SHARE_LINK";
    const noClick = viewMode === "collaborate" || !accounts?.length || isLinkShare;
    const showSettings = isEnabled("aible-settings");
    const customHeaderColor = ((location && location.pathname && location.pathname.indexOf("next") !== -1) ||
        (viewType === "new chat" && location && location.pathname && location.pathname.indexOf("chatTemplate") === -1)) &&
        chatApp?.wizard?.headerColor !== undefined &&
        chatApp?.wizard?.headerColor !== ""
        ? chatApp?.wizard.headerColor
        : undefined;
    const useChatAppLogo = ((location && location.pathname && location.pathname.indexOf("next") !== -1) ||
        (viewType === "new chat" && location && location.pathname && location.pathname.indexOf("chatTemplate") === -1)) &&
        chatApp?.wizard?.base64StringLogo !== undefined &&
        chatApp?.wizard?.base64StringLogo !== "";
    const headerColorDarkColor = "#4B495B";
    const IS_SIMPLE_MODE = true;
    if (viewingMobile) {
        return (React.createElement("div", { className: styles.header, style: hideHeader ? { display: "none" } : customHeaderColor !== undefined ? { background: customHeaderColor } : {} },
            React.createElement("div", { className: styles.headerMobile, onClick: () => history.push("/") }, !useChatAppLogo ? (React.createElement("img", { className: styles.logoImage, src: getImage(), alt: "Aible Logo" })) : (React.createElement(React.Fragment, null,
                React.createElement("img", { className: styles.appLogoImage, src: getImage(), alt: "App Logo" }),
                headerDarkMode ? (React.createElement("img", { className: styles.logoImage, src: Logo_Powered_By_Aible_Dark, alt: "Powered by Aible Logo", style: {
                        marginLeft: "16px"
                    } })) : (React.createElement("img", { className: styles.logoImage, src: Logo_Powered_By_Aible, alt: "Powered by Aible Logo", style: {
                        marginLeft: "16px"
                    } })))))));
    }
    if (isTableauMode && updateDatasetId) {
        updateDatasetId("new", undefined);
    }
    // Resetting chat and preventing page swap issues from updates
    const resetChat = () => {
        dispatch(chatGPTReducer.cancelChat(true));
        dispatch(chatGPTReducer.cancelAgent(true));
        dispatch(globalReducer.updateIsSkipChatGPTReset(undefined));
        dispatch(chatGPTReducer.resetGPT());
    };
    const handleClick = () => {
        if (noClick) {
            if (!accounts?.length && !accountsIsLoading) {
                toast("No cloud accounts found. Please link a cloud account to begin using Aible", {
                    type: toast.TYPE.ERROR,
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 5000
                });
            }
            return;
        }
        if (updateType) {
            const defaultView = localStorage.getItem("default_view");
            switch (defaultView) {
                case "chat":
                    updateType(VIEW_TYPE.NEW_CHAT);
                    break;
                case "datasets":
                    updateType(VIEW_TYPE.DATASETS);
                    break;
                case "templates":
                    updateType(VIEW_TYPE.AGENT_TEMPLATES);
                    break;
                default:
                    updateType(VIEW_TYPE.AGENT_TEMPLATES);
            }
            resetChat();
            history.push("/");
        }
        updateAgentAutonomyView();
    };
    useEffect(() => {
        const timeoutId = window.setTimeout(() => {
            if (!updateType) {
                return;
            }
            if (isEnabled("spark-with-partners")) {
                updateType(VIEW_TYPE.NEW_CHAT);
                return;
            }
            if (isEnabled("enable-agents-templates-view")) {
                updateType(VIEW_TYPE.AGENT_TEMPLATES);
                return;
            }
            const initDefaultView = localStorage.getItem("default-view") || "datasets";
            switch (initDefaultView) {
                case "chat":
                    updateType(VIEW_TYPE.NEW_CHAT);
                    break;
                case "datasets":
                    updateType(VIEW_TYPE.DATASETS);
                    break;
                case "templates":
                    updateType(VIEW_TYPE.AGENT_TEMPLATES);
                    break;
                default:
                    updateType(VIEW_TYPE.AGENT_TEMPLATES);
            }
        }, 200);
        return () => window.clearTimeout(timeoutId);
    }, []);
    return (React.createElement("div", { className: styles.header + " " + (isTableauMode || isConsumerMode ? styles.tabHeader : ""), style: hideHeader ? { display: "none" } : customHeaderColor !== undefined ? { background: customHeaderColor } : {} },
        React.createElement("a", { className: styles.name + (noClick ? " " + styles.noClick : ""), onClick: () => handleClick() }, !useChatAppLogo ? (React.createElement("img", { className: styles.logoImage, src: getImage(), alt: "Aible Logo" })) : (React.createElement(React.Fragment, null,
            React.createElement("img", { className: styles.appLogoImage, src: getImage(), alt: "App Logo" }),
            headerDarkMode ? (React.createElement("img", { className: styles.logoImage, src: Logo_Powered_By_Aible_Dark, alt: "Powered by Aible Logo", style: {
                    marginLeft: "16px"
                } })) : (React.createElement("img", { className: styles.logoImage, src: Logo_Powered_By_Aible, alt: "Powered by Aible Logo", style: {
                    marginLeft: "16px"
                } }))))),
        isEnabled("tableau-switcher") && isEnabled("tableau") !== true && false && (React.createElement("div", { className: styles.tableauHolder },
            React.createElement(Button, { type: "secondary", className: styles.tableauBtn, onClick: () => updateIsTableauMode && updateIsTableauMode(!isTableauMode) }, isTableauMode ? "Hide Tableau Mode" : "Preview For Tableau"))),
        isConsumerMode && React.createElement("div", { className: styles.recommendation }, "RECOMMENDATION"),
        isEnabled("dev-data-overview-all") && !isLinkShare && (React.createElement("div", { className: styles.midButtons },
            React.createElement("div", { className: styles.hItem + " " + styles.iText + " " + (headerMode === "OVERVIEW" ? styles.marketplaceBtn : ""), onClick: () => updateHeaderMode && updateHeaderMode("OVERVIEW") },
                React.createElement("span", { title: "Data Overview" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? globeIconDark : globeIcon, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: { color: "white" } }, "Enteprise Data Overview")),
            React.createElement("div", { className: styles.hItem + " " + styles.iText + " " + (headerMode === "WORK" ? styles.marketplaceBtn : ""), onClick: () => updateHeaderMode && updateHeaderMode("WORK") },
                React.createElement("span", { title: "My Work" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? folderIconDark : folderIcon, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: { color: "white" } }, "My Work")),
            React.createElement("div", { className: styles.hItem + " " + (headerMode === "TASKS" ? styles.marketplaceBtn : ""), onClick: () => updateHeaderMode && updateHeaderMode("TASKS") },
                React.createElement("span", { title: "Tasks and Collaboration" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? tasksIconDark : tasksIcon, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: { color: "white" } }, "Tasks and Collaboration")),
            isMarketplaceDemo ? (React.createElement("div", { className: styles.hItem + " " + styles.iText + " " + (headerMode === "MARKET" ? styles.marketplaceBtn : ""), onClick: () => {
                    if (updateHeaderMode) {
                        updateHeaderMode("MARKET");
                        history.push("/marketplace_v1");
                    }
                } },
                React.createElement("span", { title: "Aible Marketplace" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? marketplaceLogoDark : marketplaceLogo, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: { color: "white" } }, "Marketplace" + (isMarketplace ? " Demo" : "")))) : (""))),
        React.createElement("div", { className: styles.helpHolder, style: {
                color: headerDarkMode ? headerColorDarkColor : "white"
            } },
            isEnabled("chat-aible") &&
                isEnabled("completion-cache") &&
                isEnabled("chat-aible-cache-savings-indicator") &&
                !isLinkShare && React.createElement(CostSavingsIndicator, null),
            isEnabled("chat-aible-consumer") && !isLinkShare ? (React.createElement(React.Fragment, null,
                isEnabled("chat-aible-buy-button") && ENABLE_STRIPE && (React.createElement("div", { style: { marginRight: "20px" } },
                    React.createElement(StripeButton, null))),
                React.createElement("div", { style: { marginRight: "20px" } },
                    React.createElement(Button, { type: "purple2", onClick: () => window.open("https://calendly.com/aible-cs/cs-team-30") },
                        React.createElement(FontAwesomeIcon, { icon: faHeadset, style: { marginRight: "5px" } }),
                        React.createElement("span", { className: styles.iText, style: {} }, "Book 1-on-1 Support"))))) : (isEnabled("aible-explore") || isEnabled("aible-optimize")) && !isLinkShare ? (isViewingExplore ? (React.createElement("div", { className: styles.hItem + " " + styles.iText, onClick: () => {
                    if (updateIsTourOpenExplore) {
                        updateIsTourOpenExplore(true);
                    }
                } },
                React.createElement("span", { title: "Tour" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? pathFindDark : pathFind, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: {} }, "Walkthrough Explore"))) : isViewingDataTab ? (React.createElement("div", { className: styles.hItem + " " + styles.iText, onClick: () => {
                    if (updateIsTourOpenSense) {
                        updateIsTourOpenSense(true);
                    }
                } },
                React.createElement("span", { title: "Tour" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? pathFindDark : pathFind, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: {} }, "Walkthrough Sense"))) : isNewChat && !IS_SIMPLE_MODE ? (React.createElement("div", { className: styles.hItem + " " + styles.iText, onClick: () => {
                    if (updateIsOpenNewChat) {
                        updateIsOpenNewChat(true);
                    }
                }, id: "new-chat-walkthrough" },
                React.createElement("span", { title: "Tour" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? pathFindDark : pathFind, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: {} }, "Walkthrough"))) : ("")) : (React.createElement(React.Fragment, null)),
            isEnabled("community-market") && (React.createElement("div", { className: styles.hItem + " " + styles.iText + " " + styles.marketplaceBtn, onClick: () => {
                    history.push("/community_market");
                } },
                React.createElement("span", { title: "Marketplace" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? MarketplaceIconDark : MarketplaceIcon, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: {} }, "Marketplace"))),
            !isEnabled("aible-consumer") && !isEnabled("spark-agents-templates-view") && !isLinkShare && (React.createElement("a", { className: styles.hItem + " " + styles.iText, href: isEnabled("chat-aible-consumer") ? "https://community.chataible.iamaible.com/" : undefined, target: isEnabled("chat-aible-consumer") ? "_blank" : undefined, rel: "noreferrer", onClick: isEnabled("chat-aible-consumer") ? undefined : () => goToHelpUri && goToHelpUri(), style: {
                    textDecoration: "none",
                    color: headerDarkMode ? headerColorDarkColor : "#FFFFFF"
                } },
                React.createElement("span", { title: "Help" },
                    React.createElement("img", { className: styles.headerLogo, src: headerDarkMode ? questionCircleDark : questionCircle, style: { marginTop: "-2px", marginRight: "5px" } })),
                React.createElement("span", { className: styles.iText, style: {} }, "Help"))),
            React.createElement(OverlayTrigger, { placement: "bottom", trigger: "click", rootClose: true, overlay: React.createElement(Popover, { id: "popover-positioned-bottom" },
                    React.createElement("div", { style: { display: "flex", flexFlow: "column" } },
                        React.createElement("span", { style: { color: "#697586", marginBottom: "10px" } }, userEmail),
                        React.createElement("span", { style: { color: "#697586" } },
                            "Aible version: ",
                            process.env?.COMMIT_HASH?.slice(0, 6) || "Unknown"),
                        React.createElement("span", { style: { borderTop: "1px solid #E4E8EE", margin: "10px 0 5px" } }),
                        showSettings && !isLinkShare && (React.createElement("a", { onClick: () => history.push("/accounts"), style: { padding: "5px 0", color: "#697586", display: "flex", alignItems: "center" } },
                            React.createElement("span", { className: styles.help },
                                React.createElement("img", { style: { marginTop: "-2px", marginRight: "10px" }, className: styles.headerLogo, src: iconSettings })),
                            React.createElement("span", { className: styles.iText }, "Admin Settings"))),
                        React.createElement("a", { onClick: () => handleLogout(), style: { padding: "5px 0", color: "#697586", display: "flex", alignItems: "center" } },
                            React.createElement("img", { style: { marginTop: "-2px", marginRight: "10px" }, className: styles.headerLogo, src: logoutLogoDark }),
                            React.createElement("span", { className: styles.iText }, "Logout")))) },
                React.createElement("div", { className: styles.userIcon }, userName ? getInitials(userName) : "U"))),
        uploadContainer,
        React.createElement("div", null,
            React.createElement(CreateConsultantModalContainer, null),
            React.createElement(CreateJobModal, null))));
};
export default Header;
